import {
	Component,
	ElementRef,
	OnDestroy,
	OnInit,
	ViewChild
} from '@angular/core';
import { Location } from '@angular/common';
import { AccountServiceWebProvider } from '@web-services/user/account.service';
import { NavBreadcrumb, ServerDataResponse, User } from '@models/models';
import { Subject } from 'rxjs/Subject';
import { filter, takeUntil } from 'rxjs/operators';
import { MessageService } from '@services/helpers/message-service/message.service';
import { TwoFaAuthenticationDataService } from '@services/user/two-fa-authentication.data.service';
import { TwoFactorAuthorization } from '@models/two-fa.models';

@Component({
	selector: 'profile',
	template: require('./profile.html'),
	styles: [require('./profile.scss')]
})
export class ProfileComponent implements OnInit, OnDestroy {
	@ViewChild('twoFa') twoFaRef: ElementRef;
	user: User;
	editedUser: User;
	twoFactorData: TwoFactorAuthorization;
	breadcrumbs: Array<NavBreadcrumb> = [
		{ link: '/', title: 'Dashboard' },
		{ link: '/settings', title: 'Settings' },
		{ link: null, title: 'Account & Subscription' }
	];

	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private accountService: AccountServiceWebProvider,
		private twoFaAuthenticationService: TwoFaAuthenticationDataService,
		private messageService: MessageService,
		public location: Location
	) {}

	ngOnInit(): void {
		this.getUser();
		this.getTwoFaData();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	loadProfile(state: boolean): void {
		if (state) {
			this.getTwoFaData();
		}
	}

	private getUser(): void {
		this.accountService.userDataObservable
			.pipe(
				takeUntil(this.unsubscribe),
				filter(
					(user: User): boolean => user !== null && typeof user !== 'undefined'
				)
			)
			.subscribe((user: User): void => {
				this.user = JSON.parse(JSON.stringify(user));
				this.editedUser = JSON.parse(JSON.stringify(user));
			});
	}

	private getTwoFaData(): void {
		this.twoFaAuthenticationService
			.get2FaMetadataForSetup()
			.pipe(
				takeUntil(this.unsubscribe),
				filter(
					(data: ServerDataResponse<TwoFactorAuthorization>): boolean =>
						!!data.data
				)
			)
			.subscribe(
				(data: ServerDataResponse<TwoFactorAuthorization>): void => {
					this.twoFactorData = data.data;
					this.scrollIntoView('twoFaRef', 'redirectTo=2FA');
				},
				({ error }): void => {
					const { errorMessage, errorTitle } = error;
					this.messageService.showErrorFromBackend(errorTitle, errorMessage);
				}
			);
	}

	private scrollIntoView(scrollDest: string, checkPath: string): void {
		if (this.location.path().includes(checkPath)) {
			requestAnimationFrame((): void => {
				this[scrollDest].nativeElement.scrollIntoView();
			});
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/settings/profile/profile.ts